import { render, staticRenderFns } from "./DragDots.vue?vue&type=template&id=bfb1318c&"
import script from "./DragDots.vue?vue&type=script&lang=ts&"
export * from "./DragDots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports